import { NoteResult } from "common/note/dto/NoteResult";
import { useAuthCurrent } from "./auth_current";

export function useAuthCurrentIsNoteAuthor(note: NoteResult): boolean {
  const currentAuth = useAuthCurrent();
  return currentAuth?.userViewEmail === note.author;
}
